import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrSearchIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M2.23403 2.23403C-0.0988436 4.5669 -0.0988436 8.34924 2.23403 10.6821C4.52407 12.9722 8.21083 13.0142 10.5522 10.8083L10.5541 10.8102L14.1933 14.4494C14.4667 14.7228 14.9099 14.7228 15.1833 14.4494C15.4566 14.1761 15.4566 13.7328 15.1833 13.4595L11.544 9.82024C11.5145 9.79074 11.4831 9.76443 11.45 9.7413C12.9783 7.42295 12.7223 4.27421 10.6821 2.23403C8.34924 -0.0988436 4.5669 -0.0988433 2.23403 2.23403ZM3.22398 9.69217C1.43784 7.90603 1.43784 5.01012 3.22398 3.22398C5.01012 1.43784 7.90603 1.43784 9.69217 3.22398C11.4783 5.01012 11.4783 7.90603 9.69217 9.69217C7.90603 11.4783 5.01012 11.4783 3.22398 9.69217Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrSearchIconComponent;
